import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { API_IP } from "../util/config";
import { map } from "rxjs/operators";
import { CookieService } from "ngx-cookie-service";
import { StorageService } from "../services/common/storage.service";
import * as moment from "moment";

@Injectable()
export class AuthenticationService {
  private HOST: string = API_IP;
  currentUser: any;
  public token: string;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private storageService: StorageService
  ) {
    // set token if saved in local storage
    // const userStr = this.cookieService.get('currentUser')
    // if (userStr) {
    //     this.currentUser = JSON.parse(userStr);
    // }
    // this.token = this.currentUser && this.currentUser.token;
  }

  getToken(): "String" {
    return this.currentUser ? this.currentUser.token : undefined;
  }

  login(userInfo) {
    return this.http.post(this.HOST + "/login", userInfo).pipe(
      map((response) => {
        // login successful if there's a jwt token in the response
        const token = response && response["data"] && response["data"]["token"];
        const phone =
          response &&
          response["data"] &&
          response["data"]["user"]["mobilePhone"];
        const userName =
          response && response["data"] && response["data"]["user"]["userName"];

        const crewId =
          response && response["data"] && response["data"]["account"];
        const id =
          response && response["data"] && response["data"]["user"]["id"];

        let enableProxy =
          response &&
          response["data"] &&
          response["data"]["user"]["enableProxy"];
        if (enableProxy === 1) {
          enableProxy = true;
        } else {
          enableProxy = false;
        }

        let Zone = "";
        const storageZone = localStorage.getItem("Zone");
        if (storageZone) {
          Zone = storageZone;
        } else {
          Zone = "Utc";
        }
        if (token) {
          // set token property
          this.token = token;
          localStorage.setItem("token", token); // 缓存token
          localStorage.setItem(
            "expiryTime",
            moment().add(30, "m").valueOf().toString()
          ); // 缓存过期时间

          localStorage.setItem("crewId", crewId); // 缓存用户id
          localStorage.setItem("Zone", Zone); // 缓存显示日期格式
          localStorage.setItem("phone", phone); // 缓存手机号
          localStorage.setItem("userName", userName); // 缓存用户名
          localStorage.setItem("id", id); // 缓存用户名
          // 关闭代理登录功能
          // localStorage.setItem('enableProxy', enableProxy); // 缓存超级用户
          // this.cookieService.set('token', token); // 缓存token
          // this.cookieService.set('crewId', crewId); // 缓存用户id
          // this.cookieService.set('Zone', Zone); // 缓存显示日期格式
          // this.cookieService.set('phone', phone); // 缓存手机号
          return true;
        } else {
          // return false to indicate failed login
          return false;
        }
      })
    );
  }

  // getRoleInfo(name: string) {
  //     const httpParams = new HttpParams({fromObject: {
  //             'page': '1',
  //             'size': '10',
  //             'userName': name
  //         }});
  //     return this.http.get(this.HOST + '/common/user/list', {params: httpParams})
  // }
  //
  logout(): void {
    // clear token remove user from local storage to log user out
    this.token = undefined;
    this.currentUser = undefined;
    this.storageService.clearUserInfo();
    // this.permissionsService.flushPermissions();
  }
}
